// @flow
import type { ChildrenArray, Element } from 'react';
import React from 'react';
import { InternalHeading } from '../../InternalHeading.js';
import { childrenArrayMatcher } from '../../childrenArrayMatcher.js';
import {
  types as t,
  usePropsValidation,
} from '../../validation/runtime-checks/index.js';
import type { CompilerInjectedProps } from '../../validation/runtime-checks/index.js';

export function RSLTNTools(props: {
  children: ChildrenArray<
    Element<typeof RSLTNCalculatorTool> | Element<typeof RSLTNTool>,
  >,
  ...CompilerInjectedProps,
}) {
  const { failedValidation } = usePropsValidation(props, RSLTNTools);

  if (failedValidation) return null;
  return (
    <>
      <InternalHeading level={3}>Tools</InternalHeading>
      <p>You may find these tools helpful:</p>
      <ul style={{ listStyle: 'disc' }}>
        {React.Children.map(props.children, (child) => (
          <li>{child}</li>
        ))}
      </ul>
    </>
  );
}
RSLTNTools.spec = {
  children: childrenArrayMatcher(
    { min: 0, max: Infinity, elementType: t.elementType(RSLTNCalculatorTool) },
    { min: 0, max: Infinity, elementType: t.elementType(RSLTNTool) },
  ),
};

export function RSLTNCalculatorTool(props: {
  kind: 'scientific' | 'geometry' | 'graphing' | 'statistics' | '3d',
  ...CompilerInjectedProps,
}) {
  const { failedValidation } = usePropsValidation(props, RSLTNCalculatorTool);

  if (failedValidation) return null;
  const calculators = {
    scientific: 'Scientific calculator',
    geometry: 'Geometry calculator',
    graphing: 'Graphing calculator',
    statistics: 'Statistics calculator',
    '3d': '3D calculator',
  };
  return <>{calculators[props.kind]}</>;
}
RSLTNCalculatorTool.spec = {
  kind: t.unionOfValues(
    'scientific',
    'geometry',
    'graphing',
    'statistics',
    '3d',
  ),
};

export function RSLTNTool(props: {
  children: string,
  ...CompilerInjectedProps,
}) {
  const { failedValidation } = usePropsValidation(props, RSLTNTool);

  if (failedValidation) return null;
  return props.children;
}
RSLTNTool.spec = { children: t.string };
